import type { BookingConfirmationSummary } from '@massilia/queries'

import { Button } from '@massilia/ui'
import { Link } from '@tanstack/react-router'

import { CarRentalsSection } from '@/components/booking-sections/car-rentals-section'
import { ExtrasSection } from '@/components/booking-sections/extras-section'
import { HotelsSection } from '@/components/booking-sections/hotels-section'
import { InsuranceSection } from '@/components/booking-sections/insurance-section'

import type { PaymentConfirmationBookingData } from './payment-confirmation-booking-data'

import { CompleteYourTripSection } from './complete-your-trip-section'
import { PaymentConfirmationLayout } from './payment-confirmation-layout'
import { PaymentConfirmationSharedScreen } from './payment-confirmation-shared-screen'
import { paymentConfirmationVariants } from './payment-confirmation-variants'
import { SummaryRow } from './summary-row'
import { TripRecapSection } from './trip-recap-section'

interface PaymentCompleteComponentProps {
  booking: PaymentConfirmationBookingData
  summary?: BookingConfirmationSummary
}

export function PaymentCompleteComponent({ booking, summary }: PaymentCompleteComponentProps) {
  const variant = paymentConfirmationVariants.success

  return (
    <PaymentConfirmationLayout variant={variant}>
      <div className="border-gray-light-200 flex flex-col gap-3 rounded-2xl border bg-white p-6">
        <div className="text-gray-light-900 text-2xl font-semibold">{variant.title}</div>
        <p className="text-gray-light-700 text-sm">{variant.description}</p>

        <SummaryRow label="Numéro de dossier" value={booking.bookingRef} />
        <SummaryRow label="Adresse email" value={booking.customerEmail} />
        <SummaryRow label="Téléphone" value={booking.customerPhone} />
        <SummaryRow label="Tarif" value={booking.totalAmountLabel} />

        <div className="mt-2 flex flex-wrap gap-3">
          <Link to="/login">
            <Button type="button">Accéder à ma réservation</Button>
          </Link>
        </div>
      </div>

      <TripRecapSection summary={summary} />

      {summary?.insurance && <InsuranceSection insurance={summary.insurance} />}
      {summary?.hotels && summary.hotels.length > 0 && <HotelsSection hotels={summary.hotels} />}
      {summary?.carRentals && summary.carRentals.length > 0 && (
        <CarRentalsSection carRentals={summary.carRentals} />
      )}
      {summary?.extras && summary.extras.length > 0 && <ExtrasSection extras={summary.extras} />}

      <CompleteYourTripSection />

      <PaymentConfirmationSharedScreen
        departureAirportCode={summary?.flightSegments[0]?.departureLocation}
      />
    </PaymentConfirmationLayout>
  )
}
